export const postalCodeRegexp: RegExp = new RegExp(/\d{2}-\d{3}/);
